module.exports = __webpack_public_path__ + "img/imgentrew3.904dc62d.png";